import React, { useContext, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { toast } from "react-toastify";
import { bucketManager, defaultToastOptions, groupContext } from "../index.js";
import PlainEditor from "../../../../../../../merchant/panel/scripts/shared/editor/plainEditor.js";
import WindowComponent from "../../../../../../../merchant/panel/scripts/shared/window/window.js";
import FormatsCountSelector from "../formatsCountSelector/formatsCountSelector.js";
import { ImagePreviewInOrderBox } from "../imagePreviewInOrderBox/imagePreviewInOrderBox.js";
import { OfferEtraBorders } from "../offerExtraBorders/offerExtraBorders.js";
import AiSuggestionsContainer from "../aiSuggestionsContainer/aiSuggestionsContainer.js";
import "./orderingContainer.css";
import { post } from "../../../../../modules/post.js";
import { useGlobalUpdate } from "../../scripts/useGlobalUpdate.js";
import { UpdateBasketItemsCount } from "../navbar/navBar.js";
export default function OrderingContainer(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const [exited, setExited] = useState(false);
    const [ordered, setOrdered] = useState(false);
    const [choosedResource, setChoosedResource] = useState(null);
    const [alignment, setAlignment] = useState(null);
    const group = useContext(groupContext);
    const [isLoading, setIsLoading] = useState(false);
    const { emit, state } = useGlobalUpdate(UpdateBasketItemsCount);
    useEffect(() => {
        if (exited == false)
            return;
        props.onExited();
    }, [exited]);
    useEffect(() => {
        post("/api/public/clients/events", {
            event: {
                event: "order-intent",
                intentSource: props.intentSource,
                imageName: props.imageName,
            },
        }).then(() => { });
    }, []);
    async function orderImage(formats) {
        const totalCount = formats.reduce((acc, format) => acc + format.count, 0);
        if (totalCount == 0) {
            toast.warn("Prosimy wybrać co najmniej 1 sztukę zdjęcia", defaultToastOptions);
            return;
        }
        setIsLoading(true);
        try {
            await bucketManager.insertOrder(props.imageName, {
                ...props.offer,
                formats,
            }, choosedResource === null || choosedResource === void 0 ? void 0 : choosedResource.name);
            emit(state + 1);
            setOrdered(true);
        }
        catch (err) {
            if (err == 403) {
                toast.error("Zamówienie oczekuje na płatność i nie może już być edytowane. Możesz utworzyć nowe zamówienie lub opłacić aktualne.", defaultToastOptions);
            }
            return;
        }
        finally {
            setIsLoading(false);
        }
    }
    return ReactDOM.createPortal(React.createElement("div", { className: "ordering-container" },
        React.createElement(WindowComponent, { title: props.offer.title, onExit: function () { }, onExited: function () {
                setExited(true);
            }, exit: exited },
            React.createElement("div", { className: "ordering-box-grid " +
                    (!((_b = (_a = props.offer) === null || _a === void 0 ? void 0 : _a.additionalPersonalization) === null || _b === void 0 ? void 0 : _b.enabled) ?
                        "ordering-box-grid-without-customization"
                        : "") +
                    (group.hasAiModel && ordered ?
                        " ordering-box-grid-with-suggestions"
                        : "") +
                    (((_d = (_c = props.offer) === null || _c === void 0 ? void 0 : _c.additionalPersonalization) === null || _d === void 0 ? void 0 : _d.enabled) ?
                        " ordering-box-with-customization"
                        : "") },
                React.createElement(ImagePreviewInOrderBox, { imageUrl: props.imageUrl, resource: choosedResource, onSizeKnown: setAlignment }),
                !ordered && (React.createElement(FormatsCountSelector, { formatNames: props.offer.formats.map((format) => format.name), onReject: () => setExited(true), onAccept: orderImage, offer: props.offer, isLoading: isLoading })),
                ((_f = (_e = props.offer) === null || _e === void 0 ? void 0 : _e.additionalPersonalization) === null || _f === void 0 ? void 0 : _f.enabled) && !ordered ?
                    React.createElement(OfferEtraBorders, { resources: props.offer.additionalPersonalization.resources, alignment: alignment, onChoosed: (index) => setChoosedResource(props.offer.additionalPersonalization.resources[index]) })
                    : React.createElement("div", { style: { gridArea: "order-extra-customization" } }),
                !((_h = (_g = props.offer) === null || _g === void 0 ? void 0 : _g.additionalPersonalization) === null || _h === void 0 ? void 0 : _h.enabled) &&
                    group.hasAiModel &&
                    ordered && (React.createElement(AiSuggestionsContainer, { imageName: props.imageName, onExitRequest: () => props.onExited() })),
                ordered && (React.createElement("span", { className: "added-to-bucket-success" }, "Dodano do koszyka! \u2714")),
                !ordered && props.offer.extra && (React.createElement("div", { className: "order-box-description" },
                    React.createElement(PlainEditor, { label: "", example: props.offer.extra.description, editable: false, onChange: function (newValue) { } })))))), document.querySelector("#ordering-container"));
}
